import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
import { useState, useEffect } from "react";

export default function SearchBar({
  onSearchChange,
  placeholder = "Search...",
  value: controlledValue,
  debounceMs = 300,
  contextLabel = "default",
  ...props
}) {
  const [internalValue, setInternalValue] = useState(controlledValue || "");

  useEffect(() => {
    if (controlledValue !== undefined) {
      setInternalValue(controlledValue);
    }
  }, [controlledValue, contextLabel]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearchChange?.(internalValue);
    }, debounceMs);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [internalValue, onSearchChange, debounceMs]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setInternalValue(newValue);
  };

  const handleClear = () => {
    setInternalValue("");
  };

  return (
    <TextField
      variant="outlined"
      size="medium"
      placeholder={placeholder}
      value={internalValue}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: "#9ca3af" }} />
          </InputAdornment>
        ),
        endAdornment: internalValue && (
          <InputAdornment position="end">
            <IconButton
              aria-label="clear search"
              onClick={handleClear}
              edge="end"
              size="small"
              sx={{ 
                color: "#9ca3af",
                "&:hover": {
                  color: "#6b7280",
                  backgroundColor: "rgba(107, 114, 128, 0.1)"
                }
              }}
            >
              <Clear fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        minWidth: 300,
        "& .MuiOutlinedInput-root": {
          height: "40px",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          border: "1px solid #d1d5db",
          "&:hover": {
            border: "1px solid #9ca3af",
          },
          "&.Mui-focused": {
            border: "2px solid #3b82f6",
            boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
          },
          "& fieldset": {
            border: "none",
          },
        },
        "& .MuiInputBase-input": {
          color: "#111827",
          "&::placeholder": {
            color: "#9ca3af",
            opacity: 1,
          },
        },
      }}
      {...props}
    />
  );
}
